import { render, staticRenderFns } from "./CreateFollowUpTicket.vue?vue&type=template&id=e0543a82&scoped=true"
import script from "./CreateFollowUpTicket.vue?vue&type=script&lang=js"
export * from "./CreateFollowUpTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0543a82",
  null
  
)

export default component.exports